import { RootState } from '../types';

export const getCardInfo = (state: RootState) => state.virtualCard.cardInfo;
export const getPinCode = (state: RootState) => state.virtualCard.pinCode;
export const getCardRelease = (state: RootState) => state.virtualCard.cardRelease;
export const getCardUpgrade = (state: RootState) => state.virtualCard.cardUpgrade;
export const getCardRefill = (state: RootState) => state.virtualCard.cardRefill;
export const getPaymentCheck = (state: RootState) => state.virtualCard.paymentCheck;
export const getDetailsLink = (state: RootState) => state.virtualCard.detailsLink;
export const getRefillLink = (state: RootState) => state.virtualCard.refillLink;
export const getTransferLink = (state: RootState) => state.virtualCard.transferLink;
export const getVerificationCode = (state: RootState) => state.virtualCard.verificationCode;
export const getOperations = (state: RootState) => state.virtualCard.operations;
export const getInn = (state: RootState) => state.virtualCard.inn;
export const getConfigSelector = (state: RootState) => state.virtualCard.config;
export const getPasswordRecognition = (state: RootState) => state.virtualCard.passportRecognition;
